const LABEL_GROUPS = ['labelsAll', 'labelsAny', 'labelsNone'];
export const TMK_TIMEZONE = 'America/Bogota';

export const emptyTmkFilters = () => ({
  q: '',
  attention: 'all',
  createdOn: '',
  createdFrom: '',
  createdTo: '',
  assigneeId: '',
  assigneeType: null,
  assignedTeamId: '',
  labelsAll: [],
  labelsAny: [],
  labelsNone: [],
});

export const normalizeTmkFilters = value => {
  const result = { ...emptyTmkFilters(), ...value };
  result.q = result.q.trim();
  if (result.createdOn && !result.createdFrom && !result.createdTo) {
    result.createdFrom = result.createdOn;
    result.createdTo = result.createdOn;
  }
  result.createdOn = '';
  LABEL_GROUPS.forEach(key => {
    result[key] = [...new Set(result[key] || [])];
  });
  return result;
};

export const countTmkFilters = value => {
  const filters = normalizeTmkFilters(value);
  return [
    filters.q,
    filters.attention && filters.attention !== 'all',
    filters.createdFrom || filters.createdTo,
    filters.assigneeId ||
      (filters.assigneeType && filters.assigneeType !== 'all'),
    filters.assignedTeamId,
    ...LABEL_GROUPS.map(key => filters[key].length > 0),
  ].filter(Boolean).length;
};

const validDate = value => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const date = new Date(`${value}T12:00:00Z`);
  return (
    !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value
  );
};

export const dateRangeError = (from, to, requireEnd = false) => {
  if ((!from && to) || (requireEnd && (!from || !to))) return 'incomplete';
  if ((from && !validDate(from)) || (to && !validDate(to))) return 'invalid';
  if (from && to && from > to) return 'inverted';
  return '';
};

export const datePreset = (preset, now = new Date()) => {
  const today = new Intl.DateTimeFormat('en-CA', {
    timeZone: TMK_TIMEZONE,
  }).format(now);
  const offset = days => {
    const day = new Date(`${today}T12:00:00Z`);
    day.setUTCDate(day.getUTCDate() - days);
    return day.toISOString().slice(0, 10);
  };
  if (preset === 'yesterday') return { from: offset(1), to: offset(1) };
  return {
    from: offset({ today: 0, last7: 6, last30: 29 }[preset] ?? 0),
    to: today,
  };
};
